// extracted by mini-css-extract-plugin
export default {"page":"adminCollect_page__VD55K","pageWrap":"adminCollect_pageWrap__-kaiR","actions":"adminCollect_actions__Kvl4F"};